import { render } from "./BooksBox.vue?vue&type=template&id=2f98f45c&scoped=true"
import script from "./BooksBox.vue?vue&type=script&lang=js"
export * from "./BooksBox.vue?vue&type=script&lang=js"

import "./BooksBox.vue?vue&type=style&index=0&id=2f98f45c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src198257980/src/impact-vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f98f45c"]])

export default __exports__